/** Auth helpers for kitchen hub (dashboard token + order + role). */

import { loadHubProfile } from "@/lib/kitchenHubProfile";

export function productionTaskQuery(token, orderId, role, isHub) {
  const params = new URLSearchParams({ token });
  if (isHub && orderId) params.set("order_id", orderId);
  if (isHub && role) params.set("role", role);
  return params.toString();
}

export function productionAuthBody(token, orderId, role, isHub, extra = {}) {
  const profile = loadHubProfile();
  const worker = (profile?.name || "").trim();
  return {
    token,
    ...(isHub && orderId ? { order_id: orderId } : {}),
    ...(isHub && role ? { role } : {}),
    ...(isHub && worker ? { worker } : {}),
    ...extra,
  };
}

export function productionFormAuth(token, orderId, role, isHub, formData) {
  formData.append("token", token);
  if (isHub && orderId) formData.append("order_id", orderId);
  if (isHub && role) formData.append("role", role);
  const worker = (loadHubProfile()?.name || "").trim();
  if (isHub && worker) formData.append("worker", worker);
  return formData;
}
